 import { constantRoutes } from '../../router/index'
import Cookies from "../../common/cookie";

const newRouters = [];
const permission = {
  state: {
    routes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = newRouters.concat(routes)
    }
  },
  actions: {
    GenerateRoutes({commit},userInfo) {
      return new Promise(resolve => {
        const accessedRoutes = filterAsyncRouter(constantRoutes, userInfo.userInfo);
        commit('SET_ROUTES', accessedRoutes);
        resolve(accessedRoutes)
      })
    }
  }
}


function filterAsyncRouter(routers, userInfo) {
  let accessRoutes = routers;
 
  accessRoutes.forEach(item => {
    //票号登录
    // if (userInfo.logintype == 1) {
    //   if (
    //     item.name == "userInfo"
    //     ||
    //     item.name == "exhibitionRecord"
    //     ||
    //     item.name == "visitorAdmin"
    //     ||
    //     item.name == "reservation"
    //     ||
    //     item.name == "exhibitionwrap"
    //   ) {
    //     item.hidden = false;
    //   }else {
    //     item.hidden = true;
    //   }
    // }
    //当前账户为普通用户 且 为子账户
    /*if (userInfo.user_admin_state == '0' && userInfo.account == 1 && userInfo.logintype != 1) {
      if (item.name == "forum" || item.name == "subaccountManagement") {
         item.hidden = true;
      }else {
        item.hidden = false;
      }
    }*/
    //当前用户为 普通用户 且 账户不是子账户，
    if (userInfo.user_admin_state == '0' && userInfo.account == 0 && userInfo.logintype != 1) {
      if (item.name == "forum" ){
        item.hidden = true;
      }else {
        item.hidden = false;
      }
    }
    //当前用户是管理员 且 当前用户是子账户
    if (userInfo.user_admin_state == '1' && userInfo.account == 1 && userInfo.logintype != 1) {
      if (item.name == "subaccountManagement" || item.name == "exhibitorBbs" ){
         item.hidden = true;
      }else {
        item.hidden = false;
      }
    }

    if (item.children && item.children.length > 0) {
      filterAsyncRouter(item.children, userInfo);
    }
    console.log("------------>",item.name,item.hidden)
    // if (userInfo.can_exper == 0){
    //   if(item.name == "experience"){
    //     item.hidden = true;
    //   }
    //   if(item.name == "experience_gz"){
    //     item.hidden = true;
    //   }
    // }
  })
  return accessRoutes
}
export default permission
